export enum SidenavTitle {
  HOME = 'Home',
  SUBSCRIBER = 'Subscriber',
  DOCUMENTS = 'Documents',
  TRUST_ASSETS_DETAILS = 'Trust Assets Details',
  BOND_SURETY = 'Bond/Surety',
  TAXES = 'Taxes',
  FORMS = 'Forms',
  NOTES = 'Notes',
  MESSAGES = 'Messages',
  TRUST_DETAILS = 'Trust Details',
}
